module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAATFJREFUSEvFkj1Ow0AQhe2J3CF6EDT0FDRUbixXnABBzsB5kCigShGg4Ab+KTgKEn1Kr817s4tF8MbxuoBPWs3s2u/zJpro34nLsrxq2/ZBN3F8l2XZmz6ZiDDcdd0JF/rXoiiu3bNJiKvfLCBZhUiE10Y1dqsESYS/WUSW6GdJYlcjvswQ2oU9UQzl+Mja7Qf0AjJHsiUgoZKBgIRIvAIyVbJTQHZJsG7yPH/hZlRAfBLMzgbrCDfZ/J7EAbjyO8qn3Vkw9gdJkhyyHxVUVXXaNE2J9tieWPD1xzRNP7TXEw8/wmf2xILwM65+i6qT6xVMDZOBICRMtgShYdIL5oSJCuaGiYyE1/vCRIwxT6i+8HJfmAim6tz1SkiYcBLvbavhVUi4B//DRV3Xl277l0TRFzGEzwnTnX+IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huiyiJiantou.png
// module id = YdDI
// module chunks = 3